import { ERROR_ADD, ERROR_REMOVE, NOT_FOUND_ERROR_REMOVE, ERROR_PROJECT_NOT_FOUND, ALL_ERRORS_REMOVE } from '../actions/types';
//const INITIAL_STATE = [];
const INITIAL_STATE = {
    errors: [],
    notFound: null,
    notDriverProjects: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ERROR_PROJECT_NOT_FOUND:
            return Object.assign({}, state, {
                errors: [...state.errors.concat(action.error)]
            });
        case ERROR_ADD:
            switch (action.error.status) {
                case 404:
                    return state;
                default:
                    //return [...state.concat(action.error)];
                    return Object.assign({}, state, {
                        errors: [...state.errors.concat(action.error)]
                    });
            }
        case ERROR_REMOVE:
            return Object.assign({}, state, {
                errors: [...state.errors.filter((e) => e !== action.error)]
            });
        case NOT_FOUND_ERROR_REMOVE:
            return Object.assign({}, state, {
                notFound: null
            });

        case ALL_ERRORS_REMOVE:
            return Object.assign({}, state, {
                errors: []
            });

        default:
            return state;
    }
};
